import { Link } from "react-router-dom";
import useDarkLayout from "../../components/loyauts/use-dark-layout";
import useUser from "../../modules/user/hooks/use-user";
import { getLoginRoute, getMapRoute } from "../routes";
import './style.scss';

export default function RulesPage() {
    useDarkLayout();
    const { isLogged } = useUser()
    return <div className="rules-page">

        <h1>Zasady gry</h1>
        <div className="page-box with-half-links">
            <div className="page-box-content">
                <ul className='rules'>
                    <li>Na kolejnej stronie wpiszcie swoje imię/pseudonim lub nazwę Waszej drużyny oraz kod dostępu, który znajdziecie w swojej bibliotece.</li>
                    <li>Wszystkie zadania są dostępne online, ale czasami będziecie musieli poszperać w księgozbiorze swojej biblioteki, a często wstać od komputera :-)</li>
                    <li>Możecie wybrać każdą z 4 ścieżek dostępnych na mapie.</li>
                    <li>W niektórych zadaniach napotkacie karty pracy. Możecie je pobrać, a następnie wydrukować lub przepisać.</li>
                    <li>Po wykonaniu zadania potwierdźcie to przyciskiem "Zakończ zadanie”.</li>
                    <li>W nagrodę otrzymacie dostęp do kolejnego zadania na ścieżce oraz punkty doładowania w danej kategorii.</li>
                    <li>Za wykonanie wszystkich zadań z danej ścieżki otrzymacie odznakę.</li>
                    <li>Aby wrócić później do zasad gry, kliknijcie na mapie w przycisk: “Instrukcja”.</li>
                </ul>
                <p>Powodzenia</p>
            </div>
        </div>
        <div className="half-page-links">
            {isLogged && <Link className="button" to={getMapRoute()}>Rozpocznij</Link>}
            {!isLogged && <Link className="button"  to={getLoginRoute()}>Rozpocznij</Link>}

        </div>
        <div className="post-page-box-links">
        </div>
    </div>
}
